
import { defineComponent } from "vue";

export default defineComponent({
    name: "LinkageProfileConfirm",
    setup() {
        return {
        };
    }
});
